import { useEffect, useRef, useState } from "react";

export function useStudySocket(sessionCode, studentId, onMessage) {
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  useEffect(() => {
    if (!sessionCode || !studentId) return;
    let closedByUs = false;
    let retryTimer = null;

    const connect = () => {
      const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
      const ws = new WebSocket(`${base}/api/study/ws/${sessionCode}?student_id=${studentId}`);
      wsRef.current = ws;
      ws.onopen = () => setConnected(true);
      ws.onmessage = (event) => {
        try {
          onMessageRef.current(JSON.parse(event.data));
        } catch {
          /* ignore malformed message */
        }
      };
      ws.onclose = () => {
        setConnected(false);
        if (!closedByUs) retryTimer = setTimeout(connect, 2000);
      };
      ws.onerror = () => ws.close();
    };
    connect();

    return () => {
      closedByUs = true;
      if (retryTimer) clearTimeout(retryTimer);
      wsRef.current?.close();
    };
  }, [sessionCode, studentId]);

  return { connected };
}
